import { render, staticRenderFns } from "./ModalPatient.vue?vue&type=template&id=6a367de6&"
import script from "./ModalPatient.vue?vue&type=script&lang=js&"
export * from "./ModalPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports